<template>
  <span class="breakpoint-listener" style="display: none"/>
</template>

<script setup lang="ts">

/*
  We provide an empty span to fix mount error on empty template tag.
*/

import {onMounted} from 'vue'
import {breakpoints} from '~/constants/breakpoints'
import {useBreakpointsStore} from '~/store/breakpoints'

const breakpointsStore = useBreakpointsStore()

onMounted(() => {

  breakpoints.forEach((breakpoint) => {
    const _mediaQuery = window.matchMedia(
        `screen and (min-width: ${breakpoint.min}px) and (max-width: ${breakpoint.max}px)`
    )

    const changed = () => {
      if (_mediaQuery.matches && breakpointsStore.getCurrentBreakpoint?.name !== breakpoint.name) {
        breakpointsStore.setCurrentBreakpoint(breakpoint)
      }
    }

    // initial run
    window.requestAnimationFrame(changed.bind(this))

    _mediaQuery.addEventListener('change', () => {
      window.requestAnimationFrame(changed.bind(this))
    })
  })

})
</script>
